// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"6a6ad08c","1657":"6a6ad08c","6751":"100065f3"}[chunkId] + ".chunk.css";
};